module.exports = "<div id=\"extr-page\" class=\"loginPage\">\r\n<router-outlet></router-outlet>\r\n</div>\r\n"